import { Dialog, DialogContent } from '@mui/material';
import React from 'react';

import { Lab } from 'api/labs';
import { DialogChromeHeader } from 'components/atoms/Dialog/DialogChrome';
import { EditLabForm } from './EditLabForm';

interface EditLabDialogProps {
  lab: Lab | null;
  onClose: () => void;
  otherLabs: Lab[];
}

export const EditLabDialog: React.FC<EditLabDialogProps> = ({ lab, onClose, otherLabs }) => {
  return (
    <Dialog open={lab !== null} onClose={onClose} aria-labelledby="edit-lab-dialog-title" data-testid="edit-lab-dialog">
      <DialogChromeHeader
        title="Edit Lab"
        titleId="edit-lab-dialog-title"
        closeButtonAriaLabel="Close edit lab dialog"
        onClose={onClose}
      />
      <DialogContent dividers>
        {lab ? <EditLabForm lab={lab} otherLabs={otherLabs} onSuccess={onClose} onCancel={onClose} /> : null}
      </DialogContent>
    </Dialog>
  );
};
